import { render, staticRenderFns } from "./MortgageAlternativesPage.vue?vue&type=template&id=3e6b878e&scoped=true"
import script from "./MortgageAlternativesPage.vue?vue&type=script&lang=js"
export * from "./MortgageAlternativesPage.vue?vue&type=script&lang=js"
import style0 from "./MortgageAlternativesPage.vue?vue&type=style&index=0&id=3e6b878e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6b878e",
  null
  
)

export default component.exports